import { toast } from "react-toastify";

import { ApiDelete } from "../../helpers/API/ApiData";
import { getItems } from "./getItems";

type Props = {
  idForNewsDelete: string;
  setDeletionModal: (value: React.SetStateAction<boolean>) => void;
  page: number;
  countPerPage: number;
  search?: string;
  setLoadingData: (value: React.SetStateAction<boolean>) => void;
  setPage: (value: React.SetStateAction<number>) => void;
  setCountPerPage: (value: React.SetStateAction<number>) => void;
  setData: (value: React.SetStateAction<any[]>) => void;
  setCount: (value: React.SetStateAction<number>) => void;
};

export const deleteItem = async ({
  idForNewsDelete,
  page,
  countPerPage,
  search,
  setLoadingData,
  setPage,
  setCountPerPage,
  setData,
  setCount,
  setDeletionModal,
}: Props) => {
  try {
    await ApiDelete(`news/delete?id=${idForNewsDelete}`);

    setDeletionModal(false);
    toast.success("Erfolgreich gelöscht!");
    setPage(1);

    getItems({
      page: 1,
      countPerPage,
      search,
      setLoadingData,
      setPage,
      setCountPerPage,
      setData,
      setCount,
    });
  } catch (err: any) {
    toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen. Bitte versuche es erneut");
  }
};
